import api from './axiosConfig';

export const fetchCurrencies = async () => await api('/currencies');
